import { Component, computed, inject } from '@angular/core';

import { MessageDialogService } from '../../services/message-dialog.service';

const DEFAULT_ERROR_TEXT =
  'We have some technical difficulties at this moment. sorry for the inconvenience, please try again';

@Component({
  selector: 'app-message-dialog',
  imports: [],
  templateUrl: './message-dialog.html',
  styleUrl: './message-dialog.scss',
})
export class MessageDialog {
  private readonly msgService = inject(MessageDialogService);

  readonly show = computed(() => this.msgService.message() !== null);
  readonly message = computed(() => {
    const message = this.msgService.message();
    if (!message) {
      return { text: '', type: 'loader' as const };
    }
    if (!message.text && message.type === 'error') {
      return { ...message, text: DEFAULT_ERROR_TEXT };
    }
    return message;
  });

  public closeDialog(): void {
    window.location.reload();
  }
}
